import {Tooltip} from '@material-ui/core';
import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';

type RecordStatusProps = {
  count: number;
};

const ReturnedlRecords = ({count}: RecordStatusProps) => {
  return (
    <div className="record-status">
      <Tooltip title={`# of returned record(s):${count}`}>
        <CancelIcon className="status__unsuccessful" />
      </Tooltip>
      <span className="record-count">{count}</span>
    </div>
  );
};

export default ReturnedlRecords;
